import React, { Component } from 'react';
// import { IntercomAPI } from 'react-intercom';
// import PaypalExpressBtn from 'react-paypal-express-checkout';
// import StripeCheckout from 'react-stripe-checkout';
// import { Modal, ModalBody, ModalHeader, Tooltip } from 'reactstrap';
// import Cookies from 'universal-cookie';
import '../../assets/css/subscribe.css';
// import language from '../../assets/languages/language';
import App_data from '../config/App_data';
import FD from '../RestAPI/fetchData';
// import GD from '../RestAPI/getData';
// import { Elements, StripeProvider } from "react-stripe-elements";
/* eslint-disable*/
import Loader from '../../common/loader';
import { showFailure, showSuccess, showInformation } from '../../common/toast';
// import CheckoutForm from "./CheckoutForm";
import { formatMoney, hasSubscriptionRegularMix, isSubscriptionItem } from '../../utils/CommonUtils';
import userStore from '../../store/userStore';
import { trackBeginCheckout } from '../../common/analytics';

/* eslint-disable*/

class Cart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      errorMessage: "",
      cartItems: [],
      showPromoCode: true,
      couponInput: "",
      isApplyingCoupon: false,
      removingItemId: null,
      removingExtraId: null,
    };

    this.loadUserCart = this.loadUserCart.bind(this);
    this.renderEmptyCart = this.renderEmptyCart.bind(this);
    this.applyCoupon = this.applyCoupon.bind(this);
    this.removeCoupon = this.removeCoupon.bind(this);
    this.onRemoveItem = this.onRemoveItem.bind(this);
    this.onRemoveExtra = this.onRemoveExtra.bind(this);
    this.renderPackageItem = this.renderPackageItem.bind(this);
    this.proceedToCheckout = this.proceedToCheckout.bind(this);
    this.getIntervalLabel = this.getIntervalLabel.bind(this);
    // Idempotency guard so React strict-mode double-mount or rapid clicks
    // can't fire begin_checkout twice for the same cart-state navigation.
    this._beginCheckoutFired = false;
  }

  /**
   * Navigate from /cart → /checkout. Fires begin_checkout / startPayment /
   * InitiateCheckout conversion events along the way (was lost when this
   * component was rewritten — see docs/integrations/conversion-tracking.md).
   */
  proceedToCheckout() {
    try {
      if (!this._beginCheckoutFired) {
        this._beginCheckoutFired = true;
        const { cartItems } = this.state;
        const totals = this.getCartTotals();
        const profile = (userStore && userStore.profileInfo) || {};
        trackBeginCheckout({
          cartItems,
          total: (totals && totals.total) || 0,
          paymentType: '',
          userName: profile.username || '',
          userEmail: profile.email || '',
          source: (userStore && userStore.landingSource) || 'organic',
          affiliateName: (userStore && userStore.landingSourceName) || null,
        });
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Cart proceedToCheckout tracking failed:', e && e.message);
    }
    this.props.router.push('/checkout');
  }

  componentDidMount() {
    this.loadUserCart();
  }

  async loadUserCart() {
    this.setState({ isLoading: true, errorMessage: "" });

    await FD.callAPI(App_data.backend_api + "/checkout_v1/getUserCart")
      .then((resp) => {
        if (resp && resp.success) {
          this.setState({
            isLoading: false,
            errorMessage: "",
            cartItems: resp.user_cart,
            showPromoCode: resp.showPromoCode,
          });
        } else {
          const msg = (resp && resp.message) ? resp.message : "Failed to load user cart";
          this.setState({ isLoading: false, errorMessage: msg, cartItems: [] });
          showInformation(msg);
        }
        return resp;
      })
      .catch((err) => {
        this.setState({ isLoading: false, errorMessage: "Error loading user cart", cartItems: [] });
        showFailure("Error loading user cart");
      });
  }

  isUpgradeItem(item) {
    return item && item.type && String(item.type).startsWith("upgrade_");
  }

  getItemBasePrice(item) {
    const extraData = item.extraData || [];
    let addonsTotal = 0;

    for (let i = 0; i < extraData.length; i++) {
      addonsTotal += extraData[i].price;
    }

    if (item.type === "unlessUnlimited") {
      return addonsTotal;
    }

    if (this.isUpgradeItem(item)) {
      const credit = Number(item.upgrade_credit) || 0;
      return Math.max(0, item.planPrice + addonsTotal - credit);
    }

    return item.planPrice + addonsTotal;
  }

  getItemDiscountAmount(item) {
    if (!item || item.type !== "main") return 0;

    const pct = item.percent_discount;
    if (!(pct > 0)) return 0;

    // Coupon applies only to the plan price, not to add-ons
    const planPrice = Number(item.planPrice) || 0;
    return (planPrice * pct) / 100;
  }

  getCartTotals() {
    const items = this.state.cartItems || [];
    let subtotal = 0;
    let discountTotal = 0;

    for (let i = 0; i < items.length; i++) {
      subtotal += this.getItemBasePrice(items[i]);
      discountTotal += this.getItemDiscountAmount(items[i]);
    }

    const total = subtotal - discountTotal;
    return { subtotal, discountTotal, total };
  }

  anyCouponApplied(items) {
    if (!items || !items.length) return false;

    for (let i = 0; i < items.length; i++) {
      const code = items[i].coupon_code || "0";
      const pct = items[i].percent_discount;
      if (code !== "0" && pct > 0) return true;
    }
    return false;
  }

  applyCoupon() {
    const code = (this.state.couponInput || "").trim();
    if (!code) return;

    this.setState({ isApplyingCoupon: true });

    return FD.callAPI(App_data.backend_api + "/checkout_v1/applyCouponNew", { code: code })
      .then((resp) => {
        if (resp && resp.success) {
          showInformation(resp.message || "Coupon applied");
          this.setState({ couponInput: "" });
          return this.loadUserCart();
        }

        const msg = (resp && resp.message) ? resp.message : "Invalid coupon";
        showInformation(msg);
        return null;
      })
      .catch(() => {
        showFailure("Error applying coupon");
      })
      .finally(() => {
        this.setState({ isApplyingCoupon: false });
      });
  }

  removeCoupon() {
    const items = this.state.cartItems || [];
    const ids = [];

    for (let i = 0; i < items.length; i++) {
      const id = items[i].id;
      if (id > 0) ids.push(id);
    }

    if (!ids.length) return;

    this.setState({ isApplyingCoupon: true });

    return FD.callAPI(App_data.backend_api + "/checkout_v1/removeCoupon", { cartItemIds: ids })
      .then((resp) => {
        if (resp && resp.success) {
          showInformation(resp.message || "Coupon removed");
          return this.loadUserCart();
        }
        const msg = (resp && resp.message) ? resp.message : "Failed to remove coupon";
        showInformation(msg);
        return null;
      })
      .catch(() => showFailure("Error removing coupon"))
      .finally(() => this.setState({ isApplyingCoupon: false }));
  }

  onRemoveItem(cartItemId) {
    if (!(cartItemId > 0)) return;

    this.setState({ removingItemId: cartItemId });

    return FD.callAPI(App_data.backend_api + "/checkout_v1/deleteItem", { item_id: cartItemId })
      .then((resp) => {
        if (resp && resp.success) return this.loadUserCart();
        showInformation((resp && resp.message) ? resp.message : "Failed to remove item");
        return null;
      })
      .catch(() => showFailure("Error removing item"))
      .finally(() => this.setState({ removingItemId: null }));
  }

  onRemoveExtra(cartItemId, extraId) {
    if (!(cartItemId > 0) || !(extraId > 0)) return;

    this.setState({ removingExtraId: extraId });

    return FD.callAPI(App_data.backend_api + "/checkout_v1/removeExtra", {
      item_id: cartItemId,
      extra_id: extraId,
    })
      .then((resp) => {
        if (resp && resp.success) return this.loadUserCart();
        showInformation((resp && resp.message) ? resp.message : "Failed to remove addon");
        return null;
      })
      .catch(() => showFailure("Error removing addon"))
      .finally(() => this.setState({ removingExtraId: null }));
  }

  getGlobalCoupon(items) {
    if (!items || !items.length) return { couponCode: "", discountPct: null };

    for (let i = 0; i < items.length; i++) {
      const code = items[i].coupon_code;
      const pct = items[i].percent_discount;

      if (code && code !== "0" && pct > 0) {
        return {
          couponCode: code,
          discountPct: pct
        };
      }
    }

    return { couponCode: "", discountPct: null };
  }

  renderAddonOnlyItem(item) {
    const removingItemId = this.state.removingItemId;
    const base = this.getItemBasePrice(item);
    const disc = this.getItemDiscountAmount(item);
    const finalPrice = base - disc;
    const examName = item.examName || null;
    const abbr = examName ? examName.substring(0, 3).toUpperCase() : null;

    return (
      <div key={item.id} className="ct_item_block">
        <div className="ct_item_row">
          <div className="ct_item_left">
            <div className="sb_card_header_icon sb_icon_not_purchased">
              <span className="sb_header_icon_text sb_icon_text_not_purchased">{abbr}</span>
            </div>
            <div>
              <div className="ct_item_title_box">
                <div className="ct_item_title">{examName} ({item.package_type})</div>
                <span className="ct_addon_badge">ADD-ON</span>
              </div>
              <div className="ct_item_subtitle">{abbr} Exams</div>
            </div>
          </div>


          {/* <div className="ct_item_right">
                        <div className="ct_item_price">{formatMoney(finalPrice)}</div>
                        
                        <button
                        className={"ct_remove_btn" + (removingItemId === item.id ? " is_loading" : "")}
                        onClick={() => this.onRemoveItem(item.id)}
                        title="Remove"
                        >
                        <i className="ct_remove_btn_icon" />
                        </button>
                        </div> */}
        </div>

        {item.extraData && item.extraData.length > 0 && (
          <div className="ct_addons_box">
            {item.extraData.map((ex) => {
              const isInherited = !!ex.inherited;
              return (
                <div key={ex.id} className={"ct_addon_row" + (isInherited ? " ct_addon_row_inherited" : "")}>
                  <div className="ct_addon_name">
                    <span className="ct_addon_tree">└</span>{ex.title}
                  </div>
                  {isInherited ? (
                    <span className="ct_addon_included_label">included</span>
                  ) : (
                    <div className="ct_addon_right">
                      <div className="ct_item_price">{formatMoney(ex.price)}</div>
                      <button
                        className={"ct_remove_btn" + (this.state.removingExtraId === ex.id ? " is_loading" : "")}
                        onClick={() => this.onRemoveExtra(item.id, ex.id)}
                        title="Remove addon"
                      >
                        <i className="ct_remove_btn_icon" />
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
  
  getIntervalLabel(item) {
    // Return early if item is missing OR payment_interval is missing
    if (!item || !item.payment_interval) return "";

    const labels = {
      day: "Daily",
      week: "Weekly",
      month: "Monthly",
      year: "Yearly",
    };

    return labels[item.payment_interval.toLowerCase()] || "";
  }

  renderPackageItem(item) {
    const { cartItems } = this.state;
    const { couponCode, discountPct } = this.getGlobalCoupon(cartItems);
    const removingItemId = this.state.removingItemId;
    const disc = this.getItemDiscountAmount(item);
    const hasAddons = item.extraData && item.extraData.length > 0;
    const examName = item.examName || null;
    const abbr = examName ? examName.substring(0, 3).toUpperCase() : null;
    const isUpgrade = this.isUpgradeItem(item);
    const isUpgradeUnlimited = isUpgrade && item.type === 'upgrade_unlimited';
    const upgradeBadgeClass = isUpgradeUnlimited ? "ct_addon_badge ct_upgrade_badge_green" : "ct_addon_badge ct_upgrade_badge";
    // Show plan-only price (with discount if coupon, without addons)
    const planPrice = Number(item.planPrice) || 0;
    const originalPrice = item.originalPrice ? Number(item.originalPrice) : null;
    let displayPrice;
    if (isUpgrade) {
      const credit = Number(item.upgrade_credit) || 0;
      displayPrice = Math.max(0, planPrice - credit);
    } else {
      displayPrice = planPrice - disc;
    }
    const hasOriginalPrice = originalPrice !== null && originalPrice !== displayPrice;

    return (
      <div key={item.id} className="ct_item_block">
        <div className="ct_item_row">
          <div className="ct_item_left">
            <div className="sb_card_header_icon sb_icon_not_purchased">
              <span className="sb_header_icon_text sb_icon_text_not_purchased">{abbr}</span>
            </div>
            <div>
              <div className="ct_item_title_box ct_item_package_title">
                <p className="ct_item_title">
                  {isUpgrade ? item.examName + " – Upgrade to " + item.package_type : item.examName}
                </p>
                {!isUpgrade && <p className="ct_item_title">({item.package_type})</p>}
                {this.getIntervalLabel(item) ? <span className="ct_item_interval_badge">{this.getIntervalLabel(item)} </span> : ""}
                {isUpgrade && <span className={upgradeBadgeClass}>UPGRADE</span>}
                {!isUpgrade && discountPct > 0 && couponCode &&
                  <div className="ct_item_coupon_title">
                    Coupon applied (-{discountPct}%)
                  </div>
                }
              </div>
              {isUpgrade && item.upgradeFromPackageType
                ? <div className="ct_item_subtitle">From: {item.upgradeFromPackageType}</div>
                : <div className="ct_item_subtitle">{abbr} Exams</div>
              }
              {this.getIntervalLabel(item) ? <span className="ct_item_interval_subtitle">Renews {this.getIntervalLabel(item)} · cancel anytime
</span> : ""}
            </div>
          </div>

          <div className="ct_item_right">
            <div className="ct_item_price">
              {hasOriginalPrice && (
                <span className="ct_item_price_original">{formatMoney(originalPrice)}</span>
              )}
              {formatMoney(displayPrice)}
              {item.payment_interval ? <span className="ct_item_price_interval">/{item.payment_interval} </span> : ""}
            </div>

            <button
              className={"ct_remove_btn" + (removingItemId === item.id ? " is_loading" : "")}
              onClick={() => this.onRemoveItem(item.id)}
              title="Remove"
            >
              <i className="ct_remove_btn_icon" />
            </button>
          </div>
        </div>

        {hasAddons && (
          <div className="ct_addons_box">
            {item.extraData.map((ex) => {
              const isInherited = !!ex.inherited;
              return (
                <div key={ex.id} className={"ct_addon_row" + (isInherited ? " ct_addon_row_inherited" : "")}>
                  <div className="ct_addon_name">
                    <span className="ct_addon_tree">└</span>{ex.title}
                    <span className="ct_addon_badge">ADD-ON</span>
                  </div>
                  {isInherited ? (
                    <span className="ct_addon_included_label">included</span>
                  ) : (
                    <div className="ct_addon_right">
                      <div className="ct_item_price">{formatMoney(Number(ex.price || 0))}</div>
                      <button
                        className={"ct_remove_btn" + (this.state.removingExtraId === ex.id ? " is_loading" : "")}
                        onClick={() => this.onRemoveExtra(item.id, ex.id)}
                        title="Remove addon"
                      >
                        <i className="ct_remove_btn_icon" />
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* {(hasAddons || disc > 0) ? (
                    <div className="ct_line_total_row">
                        <div className="ct_line_total_label">
                            {disc > 0 ? "Line total after discount" : "Line total"}
                        </div>
                        <div className="ct_line_total_price">{formatMoney(finalPrice)}</div>
                    </div>
                ) : null} */}

        {/*{hasAddons || disc > 0 ? (*/}
        {/*    <div className="ct_line_total_row">*/}
        {/*        <div className="ct_line_total_label">*/}
        {/*            {disc > 0 ? "Line total after discount" : "Line total"}*/}
        {/*        </div>*/}
        {/*        <div className="ct_line_total_price">{formatMoney(finalPrice)}</div>*/}
        {/*    </div>*/}
        {/*) : null}*/}
      </div>
    );
  }

  renderHeader() {
    const { router } = this.props;
    const { location } = router;

    return (
      <div className="ct_container_header">
        <span
          className={
            "ct_shopping_btn " +
            (location.pathname.includes("/cart") ? "ct_is_btn_active" : "")
          }
          onClick={() => router.push("/cart")}
        >
          Shopping cart
        </span>

        <span className="ct_header_icon_arrow">→</span>

        <span
          className="ct_checkout_btn "
          onClick={this.proceedToCheckout}>
          Checkout
        </span>

        <button type="button" className="ct_continue_btn" onClick={() => router.push("/subscribe")}>
          CONTINUE SHOPPING
        </button>
      </div>
    );
  }

  renderEmptyCart() {
    const { router } = this.props;

    return (
      <div className="ct_empty_box">
        <span className="ct_empty_icon" />
        <h2 className="ct_empty_title">Your cart is empty</h2>
        <p className="ct_empty_subtitle">Browse courses and add them to your cart.</p>

        <button className="ct_empty_browser_btn" onClick={() => router.push("/subscribe")} type="button">
          Browse Courses
        </button>
      </div>
    );
  }

  renderCart() {
    const { cartItems, showPromoCode, couponInput, isApplyingCoupon } = this.state;
    const { subtotal, discountTotal, total } = this.getCartTotals();
    const { couponCode, discountPct } = this.getGlobalCoupon(cartItems);

    if (!cartItems || !cartItems.length) return this.renderEmptyCart();

    const anyCouponApplied = this.anyCouponApplied(cartItems);
    const isSubscriptionRegularMix = hasSubscriptionRegularMix(cartItems);

    return (
      <div className="ct_cart_container">
        <div className="ct_items_list">
          <div className="ct_items_title">
            <span>PRODUCT</span>
            <span>UNIT PRICE</span>
          </div>

          {cartItems.map((item) => {
            if (item.type === "unlessUnlimited") {
              return this.renderAddonOnlyItem(item);
            }
            return this.renderPackageItem(item);
          })}
        </div>

        {showPromoCode && (() => {
          // A monthly line cannot take a coupon: the subscription is billed
          // from its Stripe price, so a cart discount would be shown and then
          // not charged. `payment_interval` comes from exam_plans on the cart
          // query — the same signal the server rejects on, so the UI and
          // /applyCoupon cannot disagree.
          const isRecurringItem = (i) => !!(i && i.payment_interval);
          const couponableItems = cartItems.filter(
            i => i.type === "main" && !isRecurringItem(i)
          );
          const hasMainItem = couponableItems.length > 0;
          const hasOnlyNonCouponItems = !hasMainItem;

          if (hasOnlyNonCouponItems && !anyCouponApplied) {
            const hasUpgrade = cartItems.some(i => this.isUpgradeItem(i));
            const hasAddonOnly = cartItems.some(i => i.type === "unlessUnlimited");
            const hasRecurring = cartItems.some(
              i => i.type === "main" && isRecurringItem(i)
            );
            let msg = "Coupon is not applicable";
            if (hasRecurring) msg = "Discount codes cannot be applied to monthly plans";
            else if (hasUpgrade && !hasAddonOnly) msg = "Coupon is not applicable on upgrades";
            else if (!hasUpgrade && hasAddonOnly) msg = "Coupon is not applicable on extras";
            else if (hasUpgrade && hasAddonOnly) msg = "Coupon is not applicable on upgrades and extras";

            return (
              <div className="ct_coupon_box_container">
                <div className="ct_coupon_input_row">
                  <span className="ct_coupon_not_applicable">{msg}</span>
                </div>
              </div>
            );
          }

          return (
            <div className="ct_coupon_box_container">
              {anyCouponApplied ? (
                <div className="ct_remove_coupon_container">
                  <p className="ct_remove_title">Remove coupon:</p>
                  <div className="ct_remove_box">
                    <span className="ct_remove_label" />
                    <span className="ct_remove_subtitle">{couponCode}</span>
                    <span className="ct_remove_discount">(-{discountPct}%)</span>
                    <button
                      type="button"
                      aria-label={`Remove coupon ${couponCode}`}
                      className="ct_coupon_btn_remove"
                      disabled={isApplyingCoupon}
                      onClick={this.removeCoupon}
                    >
                      <span className="ct_remove_icon" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              ) : (
                <div className="ct_coupon_input_row">
                  <span className="ct_coupon_input_label">Add coupon:</span>
                  <div className="ct_coupon_input_col_inline">
                    <input
                      className="packages_modal_input ct_coupon_input"
                      placeholder="Type your coupon code"
                      value={couponInput}
                      onChange={(e) => this.setState({ couponInput: e.target.value })}
                      onKeyDown={(e) => e.key === "Enter" && this.applyCoupon()}
                    />
                    <button className="ct_coupon_btn_add" disabled={isApplyingCoupon}
                      onClick={this.applyCoupon}>
                      {isApplyingCoupon ? "Applying..." : "Apply coupon"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          );
        })()}

        <div className="ct_summary_box">
          <div>
            <div className="ct_summary_subtotal">
              <span>Subtotal:</span>
              <span>{formatMoney(subtotal)}</span>
            </div>
            {discountTotal > 0 && (
              <div className="ct_summary_discount">
                <span>Discount: (-{discountPct}%)</span>
                <span>-{formatMoney(discountTotal)}</span>
              </div>
            )}
            <div className="ct_summary_total">
              <span>Total:</span>
              <span>{formatMoney(total)}</span>
            </div>
          </div>


          {/*<div className="ct_summary_row ct_summary_row_total">*/}
          {/*  <span>Total</span>*/}
          {/*  <span>{formatMoney(total)}***</span>*/}
          {/*</div>*/}
          {isSubscriptionRegularMix && (
            <div className="ct_summary_warning">
              <div className="ct_summary_warning_title">
                Subscription and regular products cannot be purchased together
              </div>
              <div className="ct_summary_warning_text">
                Your cart contains a subscription package (e.g. GMAT Focus) together with a regular
                product. Please check out the subscription separately from other items to proceed.
              </div>
            </div>
          )}
          <div className="ct_summary_actions">
            <button
              className={"ct_btn_checkout" + (isSubscriptionRegularMix ? " ct_btn_disabled" : "")}
              disabled={isSubscriptionRegularMix}
              onClick={this.proceedToCheckout}
            >
              PROCEED TO CHECKOUT
            </button>
          </div>

        </div>
      </div>
    );
  }

  render() {
    const { isLoading, errorMessage, cartItems } = this.state;

    if (isLoading) {
      return (
        <div className="animated fadeIn">
          <Loader />
        </div>
      );
    }

    return (
      <div className="animated fadeIn">
        <div className="sb_page_container">
          {errorMessage ? (
            <div className="sb_error_message">{errorMessage}</div>
          ) : (
            <div>
              {this.renderHeader()}
              {!cartItems || cartItems.length === 0 ? this.renderEmptyCart() : this.renderCart()}
            </div>
          )}
        </div>
      </div>
    );
  }
}

// IntercomAPI('trackEvent', 'view-cart-page');

// class Cart extends Component { // old flow
//   constructor(props) {
//     super(props);
//     this.state = {
//       alert_status: false,
//       MessageTitle: `${language.LC().ALERT}`,
//       MessageContent: `${language.LC().ERROR}`,
//       user_cart: [],
//       token: '',
//       idname: '',
//       ValidToken: false,
//       chapter_id: '',
//       plan_data: '',
//       pack_class: 'hide_block',
//       exam_name: '',
//       exam_class: 'row',
//       total: 0,
//       primary: false,
//       checked: 'card',
//       paypal_app_id: '',
//       stripe_key: App_data.stripe_key,
//       env: '',
//       currency: '',
//       checkout: 'submit_btn_lg pointer_class',
//       cart_bottom: '',
//       discount: 0,
//       discount_exam_id: 0,
//       discount_package_type: null,
//       coupon_code: '',
//       apply_coupon_code: '',
//       coupon_wrapper_class: 'prmocode_wrap',
//       coupon_status: '',
//       coupon_status_css: '',
//       tooltipOpen: false,
//       tooltipval: `${language.LC().MAY_ENTER_COUPON}`,
//       params: window.location.href,
//       url: new URL(window.location.href),
//       source: '',
//       livemode: '',
//       client_secret: '',
//       amount: '',
//       cartIds: [],
//       user_city: '',
//       user_country: '',
//       user_ip: '',
//       startLoaderModal: false,
//       startLoaderPage: false,
//       China_price: 6.55,
//       canadian_price: 5.22,
//       usd_canadian_price: 1.26,
//       voidstate: '',
//       landingSource: 'organic',
//       landingSourceName: null,
//       username: null,
//       isLoading: true,
//       showPromoCode: true,
//     };
//     this.togglePrimary = this.togglePrimary.bind(this);
//     this.toggle = this.toggle.bind(this);
//     // this.PaypalRecurring = this.PaypalRecurring.bind(this);
//   }

//   static contextTypes = {
//     router: React.PropTypes.object,
//   };

//   toggle() {
//     this.setState({
//       tooltipOpen: !this.state.tooltipOpen,
//     });
//   }

//   _addItem = () => {
//     this.context.router.push({
//       pathname: '/subscribe/',
//       state: { token: this.state.token, idname: this.state.idname },
//     });
//   };

//   /*
//   --------------------------------------------------
//     Function to redirect page to subscribe page
//   -------------------------------------------------
//   */
//   _editItem = (item, e) => {
//     this.context.router.push({
//       pathname: '/subscribe/',
//       state: {
//         token: this.state.token,
//         idname: this.state.idname,
//         item_id: item.id,
//       },
//     });
//   };

//   /*
//   -------------------------------
//     Function to apply coupan
//   -------------------------------
//   */
//   applyCoupon = () => {
//     var coupon = document.getElementById('coupon').value;

//     if (coupon == '') {
//       this.setState({
//         ValidToken: false,
//         coupon_status_css: 'text-danger',
//         coupon_status: 'Please enter coupon code.',
//       });
//       return;
//     }

//     if (
//       this.state.user_cart &&
//       this.state.user_cart.length === 1 &&
//       this.state.user_cart[0].type === 'unlessUnlimited'
//     ) {
//       this.setState({
//         ValidToken: false,
//         coupon_status_css: 'text-danger',
//         coupon_status: 'Coupon is not applicable on extras.',
//       });
//       return;
//     }

//     let i;
//     var exam_id = [];
//     for (i = 0; i < this.state.user_cart.length; i++) {
//       exam_id.push(this.state.user_cart[i].exam_id);
//     }
//     this.setState({ isLoading: true });
//     var data = {
//       token: this.state.token,
//       idname: this.state.idname,
//       code: coupon,
//       exam_id: exam_id,
//     };
//     FD.callAPI(App_data.backend_api + '/checkout_v1/applyCoupon', data).then((resp) => {
//       if (resp != undefined && resp.success) {
//         this.setState({
//           ValidToken: true,
//           coupon_status: resp.message,
//           apply_coupon_code: coupon,
//           coupon_status_css: 'text-success',
//         });
//         FD.callAPI(App_data.backend_api + '/checkout_v1/getCart', data).then((cart_res) => {
//           // console.log("cartcvuib", cart_res);
//           this.setState({
//             landingSource: cart_res.landingSource,
//             landingSourceName: cart_res.landingSourceName,
//             username: cart_res.username,
//             showPromoCode: cart_res.showPromoCode,
//           });
//           if (cart_res.success) {
//             this.setState({
//               ValidToken: true,
//               user_cart: cart_res.user_cart,
//               isLoading: false,
//             });
//             if (cart_res.user_cart.length) {
//               this.setState({
//                 checkout: 'submit_btn_lg pointer_class',
//                 cart_bottom: '',
//               });
//             } else {
//               this.setState({
//                 checkout: 'hide_block',
//                 cart_bottom: 'hide_block',
//               });
//             }
//           } else {
//             this.setState({ ValidToken: false });
//           }
//         });
//       } else {
//         // console.log("ELSE IN COUPON");
//         this.setState({
//           coupon_status: resp.message,
//           apply_coupon_code: coupon,
//           coupon_status_css: 'text-danger',
//           ValidToken: false,
//         });
//       }
//       return resp;
//     });
//   };

//   /*
//   ------------------------------------
//     Function for ALIPAY payment
//   ------------------------------------
//   */
//   redirectToAlipay = () => {
//     // console.log(this.state.amount);
//     // console.log(
//     // "this.state.amount",
//     // this.state.amount * this.state.usd_canadian_price
//     // );
//     // console.log("this.state.usd_canadian_price", this.state.usd_canadian_price);

//     // console.log(this.state.cartIds);
//     this.setState({ startLoaderModal: true });
//     var a = this.state.amount * this.state.usd_canadian_price;
//     var data = {
//       token: this.state.token,
//       idname: this.state.idname,
//       payment_type: 'ali-pay',
//       amount: a.toFixed(2),
//       userCart: this.state.user_cart,
//       cartIds: this.state.cartIds,
//     };
//     FD.callAPI(App_data.backend_api + '/checkout_v1/addOrderAlipay', data).then(async (resp) => {
//       if (resp.success) {
//         // console.log(resp);
//         this.setState({
//           source: resp.source,
//           startLoaderModal: false,
//           isLoading: false,
//         });
//         window.location.replace(resp.source.redirect.url);
//       } else {
//         this.setState({ startLoaderModal: false });
//         // console.log("Error!!");
//       }
//     });
//   };

//   //Funtion for ALIPAY check source payment
//   //   redirectToAlipayAgain = () => {
//   //     this.setState({ startLoaderPage: true });
//   //     // console.log(this.state.amount);
//   // // console.log("sourceeeeeee",this.state.source);
//   // // console.log(" livemode: this.state.livemode,", this.state.livemode,);
//   // // console.log(" client_secret: this.state.client_secret,", this.state.client_secret,);

//   //     // console.log("working");
//   //     var a = this.state.amount * this.state.usd_canadian_price;
//   //     var data = {
//   //       token: this.state.token,
//   //       idname: this.state.idname,
//   //       payment_type: "ali-pay",
//   //       amount: a.toFixed(2),
//   //       userCart: this.state.user_cart,
//   //       cartIds: this.state.cartIds,
//   //       source: this.state.source,
//   //       livemode: this.state.livemode,
//   //       client_secret: this.state.client_secret,
//   //       user_city: this.state.user_city,
//   //       user_ip: this.state.user_ip,
//   //       user_country: this.state.user_country
//   //     };

//   //     FD.callAPI(
//   //       App_data.backend_api + "/checkout_v1/addOrderAlipayAgain",
//   //       data
//   //     ).then(async resp => {
//   //       // console.log(resp);
//   //       if (resp.success) {
//   //         // console.log(resp);
//   //         if (resp.success) {
//   //           var amount = resp.orders.amount;
//   //           this.setState({ ValidToken: true });
//   //           var order_val = this.state.user_cart;
//   //           var all_order = [];
//   //           var i = 0;
//   //           var exam_selection = [];
//   //           var exam_plans = [];
//   //           Object.keys(order_val).map(function(key) {
//   //             exam_selection.push(order_val[key].exam_id);
//   //             exam_plans.push(order_val[key].plan_id);
//   //             all_order[i] = {
//   //               exam_id: order_val[key].exam_id,
//   //               exam_name: order_val[key].exam_name,
//   //               extras: order_val[key].extraData,
//   //               package_type: order_val[key].package_type,
//   //               percent_discount: order_val[key].percent_discount,
//   //               plan_id: order_val[key].plan_id,
//   //               price: order_val[key].price
//   //             };
//   //             i++;
//   //           });
//   //           var unique = exam_selection.filter(function(elem, index, self) {
//   //             return index === self.indexOf(elem);
//   //           });
//   //           var storage_valueofExam = JSON.stringify(unique);
//   //           var storage_valueofPlan = JSON.stringify(exam_plans);

//   //           await FD.callAPI(
//   //             App_data.backend_api + "/user/getProfileInfo",
//   //             data
//   //           ).then(async resp => {
//   //             // console.log("resp");

//   //             if (resp.success) {
//   //               var examData = storage_valueofExam;
//   //               if (resp.profileInfo.exam_selected !== "") {
//   //                 var array1_new = JSON.parse(storage_valueofExam);
//   //                 var array2_old = JSON.parse(resp.profileInfo.exam_selected);
//   //                 var array3_store = array1_new.concat(array2_old);
//   //                 var unique_exam = array3_store.filter(function(
//   //                   elem,
//   //                   index,
//   //                   self
//   //                 ) {
//   //                   return index === self.indexOf(elem);
//   //                 });
//   //                 examData = JSON.stringify(unique_exam);
//   //               }

//   //               var packageData = storage_valueofPlan;
//   //               if (resp.profileInfo.exam_package !== "") {
//   //                 var array1_new = JSON.parse(storage_valueofPlan);
//   //                 var array2_old = JSON.parse(resp.profileInfo.exam_package);
//   //                 var array3_store = array1_new.concat(array2_old);
//   //                 var unique_exam = array3_store.filter(function(
//   //                   elem,
//   //                   index,
//   //                   self
//   //                 ) {
//   //                   return index === self.indexOf(elem);
//   //                 });
//   //                 packageData = JSON.stringify(unique_exam);
//   //               }
//   //               var examdata = {
//   //                 token: this.state.token,
//   //                 idname: this.state.idname,
//   //                 storage_valueofExam: examData,
//   //                 storage_valueofPlan: packageData,
//   //                 user_cart: this.state.user_cart
//   //               };
//   //               await FD.callAPI(
//   //                 App_data.backend_api + "/checkout_v1/updateOrderData",
//   //                 examdata
//   //               ).then(async resp_get => {
//   //                 //console.log('selected exam inserted');
//   //               });
//   //             }
//   //           });

//   //           var full_order_details = {
//   //             token: this.state.token,
//   //             idname: this.state.idname,
//   //             order_id: resp.orders.id,
//   //             username: resp.username,
//   //             userid: resp.userid,
//   //             payment_type: "alipay",
//   //             idname: this.state.idname,
//   //             all_order_details: all_order,
//   //             amount: amount
//   //           };
//   //           await FD.callAPI(
//   //             App_data.backend_api + "/checkout_v1/updateOrder",
//   //             full_order_details
//   //           ).then(async resp => {
//   //             if (resp.success) {
//   //               //console.log('Mail Send Successfully');
//   //             }
//   //           });
//   //           /*End Update order and send mail functionality*/
//   //           var params = {
//   //             token: this.state.token,
//   //             idname: this.state.idname,
//   //             cart_ids: this.state.cartIds,
//   //             order_id: resp.orders.id
//   //           };

//   //           await FD.callAPI(
//   //             App_data.backend_api + "/checkout_v1/updateCart",
//   //             params
//   //           ).then(response => {
//   //             if (response.success) {
//   //               this.context.router.push({
//   //                 pathname: "/thankyou/",
//   //                 state: {
//   //                   token: this.state.token,
//   //                   idname: this.state.idname,
//   //                   order_id: resp.orders.id,
//   //                   China_price: this.state.China_price,
//   //                   canadian_price: this.state.canadian_price
//   //                 }
//   //               });
//   //               window.location.reload();
//   //             }
//   //             return response;
//   //           });
//   //         }
//   //       } else {
//   //         this.setState({ startLoaderPage: false });
//   //         console.log("Error!!");
//   //         alert(resp.message);
//   //       }
//   //       return resp;
//   //     });
//   //   };

//   /*
//   --------------------------------------------
//     Function for authenticate stripe payment
//   -------------------------------------------
//   */
//   onToken = (amount, cart_ids, token) => {
//     var data = {
//       token: this.state.token,
//       idname: this.state.idname,
//       result: token,
//       payment_type: 'stripe',
//       amount: this.state.amount,
//       userCart: this.state.user_cart,
//       cartIds: this.state.cartIds,
//     };

//     var gtmData = {
//       payment_type: 'card',
//       amount: this.state.amount,
//       userCart: this.state.user_cart,
//     };
//     let endpoint = '/checkout_v1/addOrder';
//     const { user_cart: userCart } = this.state;
//     const [first] = userCart;
//     const { payment_interval } = first;
//     if (userCart.length === 1 && payment_interval !== null && payment_interval !== undefined) {
//       endpoint = '/checkout_v1/subscriptionBasedRecurringPayment';
//       data.paymentInterval = payment_interval;
//     }
//     FD.callAPI(App_data.backend_api + endpoint, data).then(async (resp) => {
//       if (resp.success) {
//         await this.GTM_Trigger(gtmData);
//         let subscriptionId = '';
//         let current_period_end;
//         if (resp.subscriptionId) {
//           subscriptionId = resp.subscriptionId;
//           current_period_end = resp.current_period_end;
//         }
//         var amount = resp.orders.amount;
//         this.setState({ ValidToken: true });
//         var order_val = this.state.user_cart;
//         var all_order = [];
//         var i = 0;
//         var exam_selection = [];
//         var exam_plans = [];
//         Object.keys(order_val).map(function (key) {
//           exam_selection.push(order_val[key].exam_id);
//           exam_plans.push(order_val[key].plan_id);
//           all_order[i] = {
//             exam_id: order_val[key].exam_id,
//             exam_name: order_val[key].exam_name,
//             extras: order_val[key].extraData,
//             package_type: order_val[key].package_type,
//             percent_discount: order_val[key].percent_discount,
//             plan_id: order_val[key].plan_id,
//             price: order_val[key].price,
//             discounted_price: Math.round(
//               order_val[key].price - (order_val[key].price * order_val[key].percent_discount) / 100,
//             ),
//             type: order_val[key].type,
//           };
//           i++;
//         });
//         var unique = exam_selection.filter(function (elem, index, self) {
//           return index === self.indexOf(elem);
//         });
//         var storage_valueofExam = JSON.stringify(unique);
//         var storage_valueofPlan = JSON.stringify(exam_plans);
//         // if (
//         //   !(userCart.length === 1 && payment_interval !== null) &&
//         //   payment_interval !== undefined
//         // ) {
//         await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async (resp) => {
//           if (resp.success) {
//             var examData = storage_valueofExam;
//             if (resp.profileInfo.exam_selected !== '') {
//               var array1_new = JSON.parse(storage_valueofExam);
//               var array2_old = JSON.parse(resp.profileInfo.exam_selected);

//               var array3_store = array1_new.concat(array2_old);
//               var unique_exam = array3_store.filter(function (elem, index, self) {
//                 return index === self.indexOf(elem);
//               });
//               examData = JSON.stringify(unique_exam);
//             }

//             var packageData = storage_valueofPlan;
//             if (resp.profileInfo.exam_package !== '') {
//               var array1_new = JSON.parse(storage_valueofPlan);
//               var array2_old = JSON.parse(resp.profileInfo.exam_package);
//               var array3_store = array1_new.concat(array2_old);
//               var unique_exam = array3_store.filter(function (elem, index, self) {
//                 return index === self.indexOf(elem);
//               });
//               packageData = JSON.stringify(unique_exam);
//             }
//             var examdata = {
//               token: this.state.token,
//               idname: this.state.idname,
//               storage_valueofExam: examData,
//               storage_valueofPlan: packageData,
//               user_cart: this.state.user_cart,
//               subscriptionId: subscriptionId,
//               current_period_end: current_period_end,
//             };
//             await FD.callAPI(App_data.backend_api + '/checkout_v1/updateOrderData', examdata).then(
//               async (resp_get) => {},
//             );
//           }
//         });
//         // }
//         var full_order_details = {
//           token: this.state.token,
//           idname: this.state.idname,
//           order_id: resp.orders.id,
//           username: resp.username,
//           userid: resp.userid,
//           payment_type: 'stripe',
//           idname: this.state.idname,
//           all_order_details: all_order,
//           amount: this.state.amount,
//           subscriptionId: subscriptionId,
//         };
//         await FD.callAPI(
//           App_data.backend_api + '/checkout_v1/updateOrder',
//           full_order_details,
//         ).then(async (resp) => {
//           if (resp.success) {
//           }
//         });
//         /*
//         ------------------------------------------------
//           End Update order and send mail functionality
//         ------------------------------------------------
//           */
//         var params = {
//           token: this.state.token,
//           idname: this.state.idname,
//           cart_ids: this.state.cartIds,
//           order_id: resp.orders.id,
//         };

//         await FD.callAPI(App_data.backend_api + '/checkout_v1/updateCart', params).then(
//           (response) => {
//             if (response.success) {
//               this.context.router.push({
//                 pathname: `/thankyou/${resp.orders.id}`,
//                 state: {
//                   token: this.state.token,
//                   idname: this.state.idname,
//                   order_id: resp.orders.id,
//                   China_price: this.state.China_price,
//                   canadian_price: this.state.canadian_price,
//                 },
//               });
//               // window.location.reload();
//             }
//             return response;
//           },
//         );
//       } else {
//         alert('Payment Failed.Please Try Again');
//       }
//       return resp;
//     });
//   };

//   /*
//   -----------------------------------------------------------------
//     For GTM trigger it's fired when a package is added to the cart
//   ------------------------------------------------------------------
//   */
//   GTM_Trigger = (data) => {
//     const { landingSourceName, landingSource, idname, username } = this.state;
//     var array = [];
//     for (let i = 0; i < data.userCart.length; i++) {
//       let extraPrice = data.userCart[i].price;
//       if (data.userCart[i].extraData && data.userCart[i].extraData.length) {
//         for (let e = 0; e < data.userCart[i].extraData.length; e++) {
//           extraPrice += data.userCart[i].extraData[e].price;
//         }
//       }
//       array.push({
//         exam: data.userCart[i].exam_name,
//         packageType: data.userCart[i].package_type,
//         price: extraPrice,
//       });
//     }
//     const tagManagerArgs = {
//       gtmId: GTM_ID,
//       dataLayer: {
//         event: GTMStartPayment,
//         eventOptions: {
//           paymentOption: data.payment_type,
//           cart: array,
//           cartTotal: data.amount,
//         },
//         userName: username,
//         userEmail: idname,
//         source: landingSource,
//         affiliateName: landingSourceName,
//         currency: Currency,
//         value: data.amount ? data.amount : 1,
//         price: data.amount,
//         currency: Currency,
//         value: data.amount ? data.amount : 1,
//       },
//     };
//     TagManager.initialize(tagManagerArgs);

//     // *************** For GA4 begin_checkout event ****************** //
//     const tagManagerArgsGA4 = {
//       gtmId: GTM_ID,
//       dataLayer: {
//         event: GA4BeginCheckout,
//         currency: Currency,
//         value: data.amount ? data.amount : 1,
//         items: array,
//         userName: username,
//         userEmail: idname,
//         source: landingSource,
//       },
//     };
//     TagManager.initialize(tagManagerArgsGA4);
//   };

//   /*
// --------------------------------------------------
//   Toggle to display alert for Pick Your Payment
// --------------------------------------------------
// */
//   togglePrimary() {
//     this.setState({
//       primary: !this.state.primary,
//     });
//   }

//   /*
//   -----------------------------------
//     Function to delete Cart Item
//   -----------------------------------
//   */
//   _deleteItem = (item, e) => {
//     var data = {
//       token: this.state.token,
//       idname: this.state.idname,
//       item_id: item.id,
//       user_id: item.user_id,
//       plan_id: item.plan_id,
//     };
//     this.setState({ isLoading: true });
//     FD.callAPI(App_data.backend_api + '/checkout_v1/deleteItem', data).then((resp) => {
//       if (resp.success) {
//         this.setState({ ValidToken: true });
//         FD.callAPI(App_data.backend_api + '/checkout_v1/getCart', data).then((response) => {
//           this.setState({
//             landingSource: response.landingSource,
//             landingSourceName: response.landingSourceName,
//             username: response.username,
//             showPromoCode: response.showPromoCode,
//           });
//           if (response.success) {
//             this.setAmount(response.user_cart);
//             this.setState({
//               ValidToken: true,
//               user_cart: response.user_cart,
//             });
//             if (response.user_cart.length) {
//               this.setState({
//                 coupon_wrapper_class: 'prmocode_wrap',
//                 checkout: 'submit_btn_lg pointer_class',
//                 cart_bottom: '',
//               });
//               // window.location.reload();
//             } else {
//               this.setState({
//                 coupon_wrapper_class: 'prmocode_wrap hide_block',
//                 checkout: 'hide_block',
//                 cart_bottom: 'hide_block',
//               });
//               // window.location.reload();
//             }
//             this.props.setIsChildChangedTrue();
//           } else {
//             this.setState({ ValidToken: false });
//           }
//           return response;
//         });
//       } else {
//         this.setState({ ValidToken: false });
//       }
//       return resp;
//     });
//   };

//   /*
// ---------------------------------------------
//   Function to get today USD to Yuan price
// ---------------------------------------------
//   */
//   getChinaPrice = () => {
//     GD.GetCallAPI('https://api.exchangeratesapi.io/latest?base=USD').then((resp) => {
//       this.setState({
//         China_price: resp.rates.CNY,
//         usd_canadian_price: resp.rates.CAD,
//       });
//     });
//     GD.GetCallAPI('https://api.exchangeratesapi.io/latest?base=CAD').then((resp) => {
//       this.setState({
//         canadian_price: resp.rates.CNY,
//       });
//     });
//   };
//   async componentDidUpdate(prevProps, prevState) {
//     if (
//       prevState.coupon_status !== this.state.coupon_status ||
//       prevState.apply_coupon_code !== this.state.apply_coupon_code
//     ) {
//       // this.getChinaPrice();

//       // console.log("componentDidUpdate Working");
//       var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
//       this.setState({
//         idname: storage_session['idname'],
//         token: storage_session['token'],
//       });
//       var data = {
//         token: storage_session['token'],
//         idname: storage_session['idname'],
//         coupon_status: this.state.coupon_status,
//       };
//       /*
//     ------------------------------
//       Api to fetch Cart Details
//     ------------------------------
//       */

//       this.setState({ isLoading: true });
//       await FD.callAPI(App_data.backend_api + '/checkout_v1/getCart', data).then((resp) => {
//         if (resp.success) {
//           this.setState({
//             landingSource: resp.landingSource,
//             landingSourceName: resp.landingSourceName,
//             username: resp.username,
//             isLoading: false,
//             showPromoCode: resp.showPromoCode,
//           });
//           // console.log("response" + resp.user_cart);
//           this.setState({ ValidToken: true });
//           if (resp.user_cart.length) {
//             this.setState({
//               user_cart: resp.user_cart,
//               checkout: 'submit_btn_lg pointer_class',
//               cart_bottom: '',
//               coupon_wrapper_class: 'prmocode_wrap',
//             });
//           } else {
//             this.setState({
//               user_cart: resp.user_cart,
//               checkout: 'hide_block',
//               cart_bottom: 'hide_block',
//               coupon_wrapper_class: 'prmocode_wrap hide_block',
//             });
//           }
//         } else {
//           this.setState({ ValidToken: false });
//         }
//         return resp;
//       });

//       {
//         let plan = this.state.user_cart;
//         var total_price = 0;
//         var new_total = 0;
//         var cart_ids = [];
//         var i = 0;
//         const cookies = new Cookies();
//         var cookie_data = cookies.get('coupon_data');
//         Object.keys(plan).map(function (key) {
//           if (plan[key].type !== 'unlessUnlimited') {
//             total_price = total_price + plan[key].price;
//           }

//           cart_ids[i] = plan[key].id;
//           if (plan[key].coupon_code) {
//             if (plan[key].type !== 'unlessUnlimited') {
//               new_total += Math.round(
//                 plan[key].price - (plan[key].price * plan[key].percent_discount) / 100,
//               );
//             }

//             if (plan[key].extraData) {
//               var extraData = plan[key].extraData;
//               Object.keys(extraData).map(function (key) {
//                 var price = extraData[key].price;
//                 new_total += price;
//               });
//             }
//           } else {
//             if (plan[key].type !== 'unlessUnlimited') {
//               new_total += plan[key].price;
//             }

//             if (plan[key].extraData) {
//               Object.keys(plan[key].extraData).map(function (key) {
//                 var price = plan[key].extraData.price;
//                 new_total += price;
//               });
//             }
//           }
//           i++;
//         });
//         this.setState({ amount: new_total, cartIds: cart_ids }, () => {
//           // console.log(this.state.amount);
//           // console.log(this.state.cartIds);
//         });
//       }
//     }
//   }

//   async componentDidMount() {
//     // console.log("didmount", typeof this.state.stripe_key);
//     GD.GetCallAPI('https://geolocation-db.com/json/').then((resp) => {
//       // console.log("resp");
//       this.setState({
//         user_city: resp.city,
//         user_country: resp.country_name,
//         user_ip: resp.IPv4,
//       });
//     });

//     const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
//     this.setState({
//       idname: storage_session['idname'],
//       token: storage_session['token'],
//     });

//     var data = {
//       token: storage_session['token'],
//       idname: storage_session['idname'],
//     };

//     /*
//     ------------------------------
//       Api to fetch Cart Details
//     ------------------------------
//     */
//     await FD.callAPI(App_data.backend_api + '/checkout_v1/getCart', data).then((resp) => {
//       if (resp.success) {
//         // console.log("response", resp.user_cart);
//         this.setState({
//           landingSource: resp.landingSource,
//           landingSourceName: resp.landingSourceName,
//           username: resp.username,
//           isLoading: false,
//           showPromoCode: resp.showPromoCode,
//         });
//         if (resp.user_cart.length) {
//           this.setState({
//             ValidToken: true,
//             user_cart: resp.user_cart,
//             checkout: 'submit_btn_lg pointer_class',
//             cart_bottom: '',
//             coupon_wrapper_class: 'prmocode_wrap',
//           });
//         } else {
//           this.setState({
//             ValidToken: true,
//             user_cart: resp.user_cart,
//             checkout: 'hide_block',
//             cart_bottom: 'hide_block',
//             coupon_wrapper_class: 'prmocode_wrap hide_block',
//           });
//         }
//       } else {
//         this.setState({ ValidToken: false });
//       }
//       return resp;
//     });

//     {
//       let plan = this.state.user_cart;
//       var total_price = 0;
//       var new_total = 0;
//       var cart_ids = [];
//       var i = 0;
//       const cookies = new Cookies();
//       var cookie_data = cookies.get('coupon_data');
//       Object.keys(plan).map(function (key) {
//         if (plan[key].type !== 'unlessUnlimited') {
//           total_price = total_price + plan[key].price;
//         }

//         cart_ids[i] = plan[key].id;
//         if (plan[key].coupon_code) {
//           if (plan[key].type !== 'unlessUnlimited') {
//             new_total += Math.round(
//               plan[key].price - (plan[key].price * plan[key].percent_discount) / 100,
//             );
//           }

//           if (plan[key].extraData) {
//             var extraData = plan[key].extraData;
//             Object.keys(extraData).map(function (key) {
//               var price = extraData[key].price;
//               new_total += price;
//             });
//           }
//         } else {
//           if (plan[key].type !== 'unlessUnlimited') {
//             new_total += plan[key].price;
//           }
//           if (plan[key].extraData) {
//             Object.keys(plan[key].extraData).map(function (key) {
//               var price = plan[key].extraData.price;
//               new_total += price;
//             });
//           }
//         }
//         i++;
//       });
//       this.setState({ amount: new_total, cartIds: cart_ids }, () => {});
//     }

//     await FD.callAPI(App_data.backend_api + '/checkout_v1/getPaymentCred', data).then(
//       (response) => {
//         if (response.success) {
//           this.setState({
//             ValidToken: true,
//             paypal_app_id: response.paypal_app_id,
//             stripe_key: response.stripe_key,
//             currency: response.currency,
//             env: response.env,
//           });
//         } else {
//           this.setState({ ValidToken: false });
//         }
//         return response;
//       },
//     );

//     // this.setState(
//     //   {
//     //     voidstate: this.state.url.searchParams.get("token")
//     //   },
//     //   () => {
//     //     this.state.voidstate ? this.PaypalRecurringAgain() : null;
//     //   }
//     // );
//   }

//   // PaypalRecurring = async () => {
//   //   console.log("this.state ", this.state.voidstate);
//   //   console.log("PaypalRecurring");

//   //   var data = {
//   //     token: this.state.token,
//   //     idname: this.state.idname,
//   //     amount: this.state.amount,
//   //     currency: this.state.currency
//   //   };

//   //   /*Api to fetch Cart Details*/
//   //   await FD.callAPI(
//   //     App_data.backend_api + "/checkout_v1/payPalRecurring",
//   //     data
//   //   ).then(resp => {
//   //     console.log("paypal recurring", resp);
//   //     if (resp.success) {
//   //       const url = resp.url;
//   //       console.log("response", url);
//   //       if (url) {
//   //         <a
//   //           href={{ url }}
//   //           target="_blank"
//   //           rel="noopener noreferrer"
//   //         />;
//   //         // var myWindow = window.open(url);
//   //         // myWindow.focus();
//   //       }
//   //       console.log("response");
//   //       console.log(
//   //         "this.state.url.searchParams.get",
//   //         this.state.url.searchParams.get("token")
//   //       );
//   //     }
//   //   });
//   // };

//   // PaypalRecurringAgain = async () => {
//   //   const token = this.state.token;
//   //   const idname = this.state.idname;
//   //   const payPaltoken = this.state.voidstate;

//   //   GD.GetCallAPI(
//   //     `${
//   //       App_data.backend_api
//   //     }/checkout_v1/payPalRecurringCheck?payPaltoken=${payPaltoken}&idname=${idname}&token=${token}`
//   //   ).then(resp => {
//   //     console.log("resunfnvd", resp);
//   //   });
//   // };

//   setAmount = (plan) => {
//     var total_price = 0;
//     var new_total = 0;
//     var cart_ids = [];
//     var i = 0;
//     const cookies = new Cookies();
//     var cookie_data = cookies.get('coupon_data');
//     Object.keys(plan).map(function (key) {
//       if (plan[key].type !== 'unlessUnlimited') {
//         total_price = total_price + plan[key].price;
//       }

//       cart_ids[i] = plan[key].id;
//       if (plan[key].coupon_code) {
//         if (plan[key].type !== 'unlessUnlimited') {
//           new_total += Math.round(
//             plan[key].price - (plan[key].price * plan[key].percent_discount) / 100,
//           );
//         }

//         if (plan[key].extraData) {
//           var extraData = plan[key].extraData;
//           Object.keys(extraData).map(function (key) {
//             var price = extraData[key].price;
//             new_total += price;
//           });
//         }
//       } else {
//         if (plan[key].type !== 'unlessUnlimited') {
//           new_total += plan[key].price;
//         }
//         if (plan[key].extraData) {
//           Object.keys(plan[key].extraData).map(function (key) {
//             var price = plan[key].extraData.price;
//             new_total += price;
//           });
//         }
//       }
//       i++;
//     });
//     this.setState({ amount: new_total, cartIds: cart_ids, isLoading: false });
//   };

//   render() {
//     var domainApp = localStorage.getItem('domainApp');
//     let plan = this.state.user_cart;
//     let data = '';
//     var i = 0;
//     const cookies = new Cookies();
//     var total_price = 0;
//     var cart_ids = [];
//     var discount = 0;
//     var cookie_data = cookies.get('coupon_data');
//     var new_total = 0;

//     Object.keys(plan).map(function (key) {
//       total_price = total_price + plan[key].price;
//       cart_ids[i] = plan[key].id;
//       if (plan[key].coupon_code) {
//         new_total += Math.round(
//           plan[key].price - (plan[key].price * plan[key].percent_discount) / 100,
//         );
//         if (plan[key].extraData) {
//           var extraData = plan[key].extraData;
//           Object.keys(extraData).map(function (key) {
//             var price = extraData[key].price;
//             new_total += price;
//           });
//         }
//       } else {
//         new_total += plan[key].price;
//         if (plan[key].extraData) {
//           Object.keys(plan[key].extraData).map(function (key) {
//             var price = plan[key].extraData.price;
//             new_total += price;
//           });
//         }
//       }
//       i++;
//     });

//     // console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", new_total);

//     const styles_css = {
//       marginBottom: '20px',
//     };

//     let env = this.state.env; // you can set here to 'production' for production
//     let currency = this.state.currency; // or you can set this value from your props or state

//     const client = {
//       // sandbox: this.state.paypal_app_id
//       production: this.state.paypal_app_id,
//     };

//     /*
//     ----------------------------
//         FOR PAYPAL PAYMENT
//     ---------------------------
//     */

//     const handlePaypalPaymentSuccess = (payment) => {
//       try {
//         var data = {
//           token: this.state.token,
//           idname: this.state.idname,
//           result: payment,
//           payment_type: 'paypal',
//           amount: this.state.amount,
//           userCart: this.state.user_cart,
//           user_ip: this.state.user_ip,
//           user_city: this.state.user_city,
//           user_country: this.state.user_country,
//         };
//         var gtmData = {
//           payment_type: 'paypal',
//           amount: this.state.amount,
//           userCart: this.state.user_cart,
//         };
//         FD.callAPI(App_data.backend_api + '/checkout_v1/addOrder', data).then(async (resp) => {
//           if (resp.success) {
//             await this.GTM_Trigger(gtmData);
//             this.setState({ ValidToken: true });
//             var amount = resp.orders.amount;
//             var order_val = this.state.user_cart;
//             var all_order = [];
//             var i = 0;
//             var exam_selection = [];
//             var exam_plans = [];
//             Object.keys(order_val).map(function (key) {
//               exam_selection.push(order_val[key].exam_id);
//               exam_plans.push(order_val[key].plan_id);
//               all_order[i] = {
//                 exam_id: order_val[key].exam_id,
//                 exam_name: order_val[key].exam_name,
//                 extras: order_val[key].extraData,
//                 package_type: order_val[key].package_type,
//                 percent_discount: order_val[key].percent_discount,
//                 plan_id: order_val[key].plan_id,
//                 price: order_val[key].price,
//                 type: order_val[key].type,
//                 discounted_price: Math.round(
//                   order_val[key].price -
//                     (order_val[key].price * order_val[key].percent_discount) / 100,
//                 ),
//               };
//               i++;
//             });
//             var unique = exam_selection.filter(function (elem, index, self) {
//               return index === self.indexOf(elem);
//             });
//             var storage_valueofExam = JSON.stringify(unique);
//             var storage_valueofPlan = JSON.stringify(exam_plans);

//             await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(
//               async (resp) => {
//                 if (resp.success) {
//                   var examData = storage_valueofExam;
//                   if (resp.profileInfo.exam_selected !== '') {
//                     var array1_new = JSON.parse(storage_valueofExam);
//                     var array2_old = JSON.parse(resp.profileInfo.exam_selected);

//                     var array3_store = array1_new.concat(array2_old);
//                     var unique_exam = array3_store.filter(function (elem, index, self) {
//                       return index === self.indexOf(elem);
//                     });
//                     examData = JSON.stringify(unique_exam);
//                   }

//                   var packageData = storage_valueofPlan;
//                   if (resp.profileInfo.exam_package !== '') {
//                     var array1_new = JSON.parse(storage_valueofPlan);
//                     var array2_old = JSON.parse(resp.profileInfo.exam_package);
//                     var array3_store = array1_new.concat(array2_old);
//                     var unique_exam = array3_store.filter(function (elem, index, self) {
//                       return index === self.indexOf(elem);
//                     });
//                     packageData = JSON.stringify(unique_exam);
//                   }
//                   var examdata = {
//                     token: this.state.token,
//                     idname: this.state.idname,
//                     storage_valueofExam: examData,
//                     storage_valueofPlan: packageData,
//                     user_cart: this.state.user_cart,
//                   };

//                   await FD.callAPI(
//                     App_data.backend_api + '/checkout_v1/updateOrderData',
//                     examdata,
//                   ).then(async (resp_get) => {
//                     // console.log("selected exam inserted");
//                   });
//                 }
//               },
//             );

//             var full_order_details = {
//               token: this.state.token,
//               idname: this.state.idname,
//               order_id: resp.orders.id,
//               username: resp.username,
//               userid: resp.userid,
//               payment_type: 'paypal',
//               idname: this.state.idname,
//               all_order_details: all_order,
//               amount: amount,
//             };
//             await FD.callAPI(
//               App_data.backend_api + '/checkout_v1/updateOrder',
//               full_order_details,
//             ).then(async (resp) => {
//               if (resp.success) {
//                 // console.log("Mail Send Successfully");
//               }
//             });
//             var params = {
//               token: this.state.token,
//               idname: this.state.idname,
//               cart_ids: this.state.cartIds,
//               order_id: resp.orders.id,
//             };
//             await FD.callAPI(App_data.backend_api + '/checkout_v1/updateCart', params).then(
//               (response) => {
//                 if (response.success) {
//                   showSuccess('Payment successful! Your packages have been upgraded.');
//                   this.context.router.push({
//                     pathname: `/thankyou/${resp.orders.id}`,
//                     state: {
//                       token: this.state.token,
//                       idname: this.state.idname,
//                       order_id: resp.orders.id,
//                       China_price: this.state.China_price,
//                       canadian_price: this.state.canadian_price,
//                     },
//                   });
//                   // window.location.reload();
//                 } else {
//                   showFailure(
//                     'Payment failed or there was an issue updating your packages. Please contact support.',
//                   );
//                 }
//                 return response;
//               },
//             );
//           } else {
//             //this.setState({ValidToken : false});
//           }
//           return resp;
//         });
//       } catch (error) {
//         console.error('Payment processing error:', error);
//         showFailure(
//           'Payment failed or there was an issue updating your packages. Please contact support.',
//         );
//       }
//     };

//     const onCancel = (data) => {
//       console.log('Payment cancelled by user', data);
//       showFailure('Payment was cancelled. No charges were made.');
//     };

//     const onError = (err) => {
//       console.error('PayPal payment error:', err);
//       showFailure('An error occurred during the payment. Please try again.');
//     };

//     if (this.state.user_cart.length) {
//       data = Object.keys(plan).map((item, index) => (
//         <tbody key={index}>
//           <tr key={index} className='package-detail'>
//             <td width='50%'>
//               {plan[item].package_val === 'unlimited' ||
//               plan[item].plan_id === 27 ||
//               plan[item].plan_id === 30 ||
//               plan[item].plan_id === 33 ||
//               plan[item].plan_id === 35
//                 ? null
//                 : plan[item].exam_name}
//               <span>
//                 {plan[item].package_val === 'unlimited' ||
//                 plan[item].plan_id === 27 ||
//                 plan[item].plan_id === 30 ||
//                 plan[item].plan_id === 33 ||
//                 plan[item].plan_id === 35
//                   ? plan[item].package_type
//                   : ` (${plan[item].package_type})`}

//                 {/* &nbsp;({plan[item].package_type}){" "} */}
//                 {plan[item].package_type == 'addon' ? plan[item].package_desc : ''}
//               </span>
//             </td>

//             {
//               plan[item].type === 'unlessUnlimited' ? (
//                 <td width='8%' className='text-center pl-0'>
//                   {' '}
//                 </td>
//               ) : (
//                 // domainApp === 'WORLD' ?
//                 <td width='8%' className='text-center pl-0'>
//                   ${plan[item].price}
//                 </td>
//               )
//               // : (
//               //   <td width='8%' className='text-center pl-0'>
//               //     ¥ {Math.ceil(Math.ceil(plan[item].price * this.state.China_price) / 10) * 10 - 1}
//               //   </td>
//               // )
//             }

//             {
//               plan[item].type === 'unlessUnlimited' ? (
//                 <td width='8%' className='text-center pl-0'>
//                   {' '}
//                 </td>
//               ) : (
//                 // domainApp === 'WORLD' ?
//                 <td width='8%' className='text-center pl-0'>
//                   $
//                   {plan[item].percent_discount != '' && plan[item].coupon_code != ''
//                     ? (discount =
//                         Number(plan[item].price * Number(plan[item].percent_discount)) / 100)
//                     : ''}
//                 </td>
//               )
//               // : (
//               //   <td width='8%' className='text-center pl-0'>
//               //     ¥{' '}
//               //     {plan[item].percent_discount != '' && plan[item].coupon_code != ''
//               //       ? (discount =
//               //         (Math.ceil(
//               //           Math.ceil(
//               //             Number(plan[item].price * Number(plan[item].percent_discount)) / 100,
//               //           ) * this.state.China_price,
//               //         ) /
//               //           10) *
//               //         10)
//               //       : ''}
//               //   </td>
//               // )
//             }

//             <td width='20%' className='text-center pl-0'>
//               <button
//                 type='button'
//                 className='btn-link pointer_class cart_button'
//                 onClick={this._deleteItem.bind(this, plan[item])}
//                 title='Delete'
//               >
//                 <img
//                   src={App_data.frontend_url + '/img/subscription/subscription_icon1.svg'}
//                   className=''
//                   width='15'
//                   alt=''
//                 />
//               </button>
//             </td>
//           </tr>
//           {plan[item].extraData
//             ? plan[item].extraData.map((extra, index) => {
//                 return (
//                   <tr key={index} className='package-extras'>
//                     {/* {console.log(extra)} */}
//                     <td width='50%' className='extras-title'>
//                       {'- ' + extra.title}
//                     </td>
//                     {
//                       // domainApp === 'WORLD' ?
//                       <td width='8%' className='pl-0'>
//                         {' '}
//                         ${extra.price}
//                       </td>
//                       // : (
//                       //   <td width='8%' className='pl-0'>
//                       //     ¥
//                       //     {Math.ceil(
//                       //       Math.ceil(Number(extra.price) * Number(this.state.China_price)) / 10,
//                       //     ) *
//                       //       10 -
//                       //       1}
//                       //   </td>
//                       // )
//                     }
//                   </tr>
//                 );
//               })
//             : ''}
//         </tbody>
//       ));
//     } else {
//       data = (
//         <tbody>
//           <tr>
//             <td colSpan={4} className='text-center'>
//               <h6> {language.LC().YOUR_CART_IS_EMPTY} </h6>
//             </td>
//           </tr>
//         </tbody>
//       );
//     }

//     let loaderData = <Loader />;
//     const { isLoading, showPromoCode, user_cart = [] } = this.state;

//     const shouldShowPromoAndPaypal =
//       showPromoCode &&
//       !user_cart.some((item) => item && item.plan_id === EXAM_PACKAGE_IDS.GMAT_FOCUS.PRACTICE);

//     return (
//       <div className='animated fadeIn'>
//         {this.state.startLoaderPage ? <Loader /> : null}
//         <div className='row'>
//           <div className='col-sm-12'>
//             <div className='card margin_bottom_20'>
//               <div className='card-header'>
//                 <h4> {language.LC().YOUR_CART} </h4>
//                 <h6>
//                   {' '}
//                   {
//                     // domainApp === 'WORLD' ?
//                     language.LC().PLEASE_VERIFY_THE_EXAM_AND_LEVEL_FOR_YOUR_PURCHASE
//                     // : null
//                   }{' '}
//                 </h6>
//               </div>
//               <div className='card-block'>
//                 <div className='row'>
//                   <div className='col-lg-8 col-xl-9 margin_bottom_30'>
//                     <div className='table_responsive_wrapper'>
//                       <div className='table-responsive cart'>
//                         <table className='cart_package_table table_white_bg table'>
//                           <thead>
//                             <tr>
//                               <th width='30%'>{language.LC().PACKAGE}</th>

//                               <th width='8%'>{language.LC().PRICE}</th>

//                               <th width='8%'>{language.LC().DISCOUNT}</th>
//                               <th width='20%'>{language.LC().DELETE_FROM_CART}</th>
//                             </tr>
//                           </thead>
//                           {isLoading ? loaderData : data}

//                           <tfoot>
//                             <tr className={this.state.cart_bottom}>
//                               <td> {language.LC().PAYABLE_TODAY} </td>
//                               {/* <td colSpan={1}>${this.state.amount}</td> */}
//                               {
//                                 // domainApp === 'WORLD' ?
//                                 <td colSpan={1} className='text-center pl-0'>
//                                   $
//                                   {this.state.amount
//                                     ? parseInt(this.state.amount).toFixed(2)
//                                     : this.state.amount}
//                                 </td>
//                                 // : (
//                                 //   <td colSpan={1} className='text-center pl-0'>
//                                 //     ¥
//                                 //     {this.state.amount
//                                 //       ? parseInt(
//                                 //         Math.ceil(
//                                 //           Math.ceil(this.state.amount * this.state.China_price) /
//                                 //           10,
//                                 //         ) *
//                                 //         10 -
//                                 //         1,
//                                 //       ).toFixed(2)
//                                 //       : Math.ceil(
//                                 //         Math.ceil(this.state.amount * this.state.China_price) / 10,
//                                 //       ) *
//                                 //       10 -
//                                 //       1}
//                                 //   </td>
//                                 // )
//                               }
//                               <td colSpan={2}>
//                                 <p className={this.state.coupon_status_css}>
//                                   <b>{this.state.coupon_status}</b>
//                                 </p>
//                               </td>
//                             </tr>
//                           </tfoot>
//                         </table>
//                       </div>
//                     </div>
//                   </div>
//                   {shouldShowPromoAndPaypal && (
//                     <div className='col-lg-4 col-xl-3'>
//                       <div className={this.state.coupon_wrapper_class}>
//                         <h6>
//                           {language.LC().HAVE_A_PROMOTIONAL_CODE}?{' '}
//                           <Tooltip
//                             placement='left'
//                             isOpen={this.state.tooltipOpen}
//                             target='TooltipExample'
//                             toggle={this.toggle}
//                           >
//                             {this.state.tooltipval}
//                           </Tooltip>
//                           <img
//                             src={`${App_data.frontend_url}/img/info_icon.svg`}
//                             className='margin_left_10'
//                             id='TooltipExample'
//                             alt='promotion code'
//                             width='20'
//                           />
//                         </h6>
//                         <div className='promo_form'>
//                           <input type='text' id='coupon' name='coupon' />
//                           <button onClick={this.applyCoupon}>{language.LC().APPLY}</button>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className='row'>
//                   <div className='col-xl-9'>
//                     <div className='cart_btn_wrp'>
//                       <div className='row'>
//                         <div className='col-sm-8'>
//                           <button
//                             className='submit_btn_lg margin_right_10 btn btn-primary margin_bottom_10'
//                             onClick={this._addItem}
//                           >
//                             {language.LC().ADD_SUBSCRIPTION}
//                           </button>
//                         </div>

//                         {this.state.user_cart.length ? (
//                           <div className='col-sm-4 text-sm-right'>
//                             <button
//                               className={'btn btn-primary ' + this.state.checkout}
//                               onClick={this.togglePrimary}
//                             >
//                               {language.LC().PROCEED_TO_PAY}
//                             </button>
//                             <Modal
//                               isOpen={this.state.primary}
//                               toggle={this.togglePrimary}
//                               className={'modal-primary ' + this.props.className}
//                             >
//                               <ModalHeader toggle={this.togglePrimary}>
//                                 {language.LC().PICK_YOUR_PAYMENT} !
//                               </ModalHeader>

//                               <ModalBody>
//                                 {this.state.startLoaderModal ? <Loader /> : null}
//                                 {
//                                   // domainApp === 'WORLD' ?
//                                   <div className='row pay-catagry-wrap'>
//                                     <div className='col-sm-12 col-md-12 pay-catagry-block'>
//                                       <div className='pay_btn_wrap'>
//                                         <p className='margin_bottom_30'>
//                                           {language.LC().PAY_WITH_CARD}
//                                         </p>
//                                         <div className='row'>
//                                           <div className='col-md-8 col-lg-8 align-self-center'>
//                                             <ul className='card_list'>
//                                               <li className='list-item'>
//                                                 <img
//                                                   src={
//                                                     App_data.frontend_url +
//                                                     '/img/subscription/cart_icon1.png'
//                                                   }
//                                                   className=''
//                                                   alt=''
//                                                 />
//                                               </li>
//                                               <li className='list-item'>
//                                                 <img
//                                                   src={
//                                                     App_data.frontend_url +
//                                                     '/img/subscription/cart_icon2.png'
//                                                   }
//                                                   className=''
//                                                   alt=''
//                                                 />
//                                               </li>
//                                               <li className='list-item'>
//                                                 <img
//                                                   src={
//                                                     App_data.frontend_url +
//                                                     '/img/subscription/cart_icon3.png'
//                                                   }
//                                                   className=''
//                                                   alt=''
//                                                 />
//                                               </li>
//                                               <li className='list-item'>
//                                                 <img
//                                                   src={
//                                                     App_data.frontend_url +
//                                                     '/img/subscription/cart_icon4.png'
//                                                   }
//                                                   className=''
//                                                   alt=''
//                                                 />
//                                               </li>
//                                             </ul>
//                                           </div>
//                                           <div className='col-md-4 col-lg-4 align-self-center text-right'>
//                                             {this.state.stripe_key ? (
//                                               <StripeCheckout
//                                                 name='AnalystPrep'
//                                                 email={this.state.idname}
//                                                 description='Purchase Packages'
//                                                 panelLabel={language.LC().PAY}
//                                                 amount={this.state.amount * 100}
//                                                 currency='USD'
//                                                 token={this.onToken.bind(
//                                                   this,
//                                                   this.state.amount,
//                                                   this.state.cartIds,
//                                                 )}
//                                                 stripeKey={this.state.stripe_key}
//                                               />
//                                             ) : null}
//                                           </div>
//                                         </div>
//                                       </div>
//                                     </div>

//                                     {shouldShowPromoAndPaypal && (
//                                       <div className='col-sm-12 col-md-12 pay-catagry-block  margin_top_10'>
//                                         <div className='pay_btn_wrap'>
//                                           <p className='pay_btn_title margin_bottom_30'>
//                                             {language.LC().PAY_WITH_PAYPAL_NORMAL}
//                                           </p>
//                                           <div className='row'>
//                                             <div className='col-md-8 col-lg-8 align-self-center pay-pal-tile'>
//                                               <img
//                                                 src={`${App_data.frontend_url}/img/subscription/cart_icon5.png`}
//                                                 className=''
//                                                 height='25'
//                                                 alt='paypal icon'
//                                               />
//                                             </div>
//                                             <div className='col-md-4 col-lg-4 align-self-center text-right'>
//                                               <div className='paypal_btn_wrap'>
//                                                 <button className='paypal_btn'>
//                                                   {language.LC().PAY_WITH_PAYPAL_CAPITAL}
//                                                 </button>
//                                                 <div
//                                                   className='paypal_iframe'
//                                                   id='paypal-button-container'
//                                                 >
//                                                   <PaypalExpressBtn
//                                                     env={this.state.env}
//                                                     client={client}
//                                                     currency={this.state.currency}
//                                                     total={this.state.amount}
//                                                     onError={onError}
//                                                     onSuccess={handlePaypalPaymentSuccess}
//                                                     onCancel={onCancel}
//                                                     style={{
//                                                       size: 'responsive',
//                                                       color: 'blue',
//                                                       tagline: false,
//                                                       label: 'pay',
//                                                       height: 45,
//                                                     }}
//                                                   />
//                                                 </div>
//                                               </div>
//                                             </div>
//                                           </div>
//                                         </div>
//                                       </div>
//                                     )}
//                                   </div>
//                                   // : (
//                                   //   <div className='row pay-catagry-wrap'>
//                                   //     <div className='ali-pay-wrap margin_bottom_60 margin_top_10 col-sm-12'>
//                                   //       <p className='pay_btn_title margin_bottom_30'>
//                                   //         {language.LC().PAY_WITH_ALIPAY_NORMAL}
//                                   //       </p>
//                                   //       <div className='pay_btn_wrap ali-pay-btn-block'>
//                                   //         <div className='pay-catagry-block'>
//                                   //           <div className='row'>
//                                   //             <div className='col-md-8 col-lg-8 align-self-center'>
//                                   //               <ul className='card_list'>
//                                   //                 <li className='list-item'>
//                                   //                   <img
//                                   //                     src={
//                                   //                       App_data.frontend_url +
//                                   //                       '/img/subscription/alipay.png'
//                                   //                     }
//                                   //                     style={{ height: '40px' }}
//                                   //                     alt=''
//                                   //                   />
//                                   //                 </li>
//                                   //               </ul>
//                                   //             </div>
//                                   //             <div className='col-md-4 col-lg-4 align-self-center text-right'>
//                                   //               <Button
//                                   //                 onClick={this.redirectToAlipay.bind(this)}
//                                   //                 className='submit_btn_lg margin_right_10 margin_bottom_10 btn btn-primary ali-pay-submit'
//                                   //               >
//                                   //                 {' '}
//                                   //                 {language.LC().PAY_WITH_ALIPAY_CAPITAL}
//                                   //               </Button>
//                                   //             </div>
//                                   //           </div>
//                                   //         </div>
//                                   //       </div>
//                                   //     </div>
//                                   //   </div>
//                                   // )
//                                 }
//                               </ModalBody>
//                             </Modal>
//                           </div>
//                         ) : (
//                           ''
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <p>
//           {' '}
//           *
//           {
//             // domainApp === 'WORLD' ?
//             language.LC().All_prices_are_in_US_dollars_All_sales_are_final
//             // : language.LC().All_sales_are_final
//           }
//         </p>
//       </div>
//     );
//   }
// }

export default Cart;



// WEBPACK FOOTER //
// ./src/views/Cart/Cart.js